import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.svg";
import ArabicLogo from "../assets/images/ar-logo.svg";
import { RiGlobalLine } from "react-icons/ri";
import { HiMenuAlt3 } from "react-icons/hi";
import { HiOutlineXMark } from "react-icons/hi2";
import { IoIosArrowDown } from "react-icons/io";
import { FiArrowUpRight } from "react-icons/fi";
import { LazyLoadImage } from "react-lazy-load-image-component";
import langData from "../locales/langData.json";
import "./Header.css";

const Header = ({ language, setLanguage }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [showNavbar, setShowNavbar] = useState(true);

  const nav = langData[language].navbar;
  // const toggleLanguage = () => setLanguage(language === "en" ? "ar" : "en");
  const hideTimeoutRef = useRef(null);

  const toggleLanguage = () => {
  const newLang = language === "en" ? "ar" : "en";
  setLanguage(newLang);

  if (location.pathname.includes("/insights/")) {
    const parts = location.pathname.split("/");
    parts[2] = newLang; // /insights/{lang}/{id}
    navigate(parts.join("/"));
  }

  if (location.pathname.includes("/news/")) {
    const parts = location.pathname.split("/");
    parts[2] = newLang; // /news/{lang}/{id}
    navigate(parts.join("/"));
  }
};



  useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none"; // iOS fix
  } else {
    document.body.style.overflow = "";
    document.body.style.touchAction = "";
  }

  return () => {
    document.body.style.overflow = "";
    document.body.style.touchAction = "";
  };
}, [menuOpen]);

 useEffect(() => {
  const navbar = document.querySelector(".custom-navbar");
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    // ✅ Mobile: always visible
    if (window.innerWidth < 992) {
      setShowNavbar(true);
      return;
    }

    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      setShowNavbar(false);
    } else {
      setShowNavbar(true);
    }

    if (navbar) {
      if (currentScrollY > 80) navbar.classList.add("scrolled");
      else navbar.classList.remove("scrolled");
    }

    lastScrollY = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);




  const isAdmin = localStorage.getItem("isAdmin") === "true";

  return (
    <div className={`navs ${language === "ar" ? "rtl" : "ltr"}`}>
      <Navbar
        expand="lg"
        className={`custom-navbar ${showNavbar ? "visible" : "hidden"}`}
      >
        <Container className="d-flex justify-content-between align-items-center">
          {/* Logo */}
          <Navbar.Brand as={Link} to="/">
            <LazyLoadImage
              src={language === "ar" ? ArabicLogo : Logo}
              alt="Logo"
              className="logo"
            />
          </Navbar.Brand>

          {/* Mobile Menu Toggle */}
          <div
            className="menu-icon d-lg-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? (
              <HiOutlineXMark size={26} color="#000" />
            ) : (
              <HiMenuAlt3 size={30} color="#000" />
            )}
          </div>

          {/* Desktop Navigation */}
          <Nav className="d-none d-lg-flex mx-auto align-items-center desktop-nav">
            {nav.navlinks.map((item, index) => {
              const slug = item.key === "home" ? "/" : `/${item.key}`;
              const isActive = location.pathname === slug;

              const isDropdown = ["products", "company", "careers"].includes(
                item.key
              );
             const isMega = ["products", "careers"].includes(item.key);

              const isOpen = activeDropdown === item.key;

              return (
                <div
                  key={index}
                  className={`nav-item-wrapper ${isActive ? "active" : ""}`}
                  onMouseEnter={() => {
                    if (hideTimeoutRef.current) {
                      clearTimeout(hideTimeoutRef.current);
                      hideTimeoutRef.current = null;
                    }
                    isDropdown && setActiveDropdown(item.key);
                  }}
                  onMouseLeave={() => {
                    if (!isDropdown) return;

                    hideTimeoutRef.current = setTimeout(() => {
                      setActiveDropdown(null);
                    }, 400);
                  }}
                >
                  {/* PRODUCTS = BUTTON | OTHERS = LINK */}
                  {isMega ? (
                    <button
                      type="button"
                      className="custom-link"
                      style={{ background: "none", border: "none" }}
                    >
                      <span>{item.label}</span>
                      <IoIosArrowDown className="nav-arrow" />
                    </button>
                  ) : (
                    <Link
                      to={slug}
                      className={`custom-link ${isActive ? "active" : ""}`}
                    >
                      <span>{item.label}</span>
                      {isDropdown && <IoIosArrowDown className="nav-arrow" />}
                    </Link>
                  )}

                  {/* DROPDOWN (unchanged) */}
                  {isDropdown && isOpen && (
                    <div className="horizontal-dropdown">
                      {(item.key === "products"
                        ? nav.productdrop
                        : item.key === "company"
                        ? nav.companydrop
                        : nav.careersdrop
                      ).map((sub, i) => (
                        <center key={i}>
                          <Link
                            to={
                              item.key === "products"
                                ? `/products/${sub.key}`
                                : item.key === "company"
                                ? `/company${sub.anchor}`
                                : `/careers/${sub.key}`
                            }
                            className="dropdown-item"
                          >
                            {sub.label}
                            <FiArrowUpRight className="arrow-icons" />
                          </Link>
                        </center>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </Nav>

          {/* Desktop - Lang + Admin + Contact */}
          <div className="d-none d-lg-flex align-items-center">
            <div
              className="lang ms-3"
              onClick={toggleLanguage}
              style={{ cursor: "pointer" }}
            >
              {language === "en" ? "AR" : "EN"} <RiGlobalLine />
            </div>

            {isAdmin && (
              <button
                className="bt-head ms-2"
                onClick={() => {
                  localStorage.removeItem("isAdmin");
                  window.location.reload();
                }}
              >
                {language === "en" ? "Logout" : "تسجيل الخروج"}
              </button>
            )}

            <Link to="/contact" className="text-decoration-none">
              <div className="bt-head  ms-3">{nav.letsTalk}</div>
            </Link>
          </div>
        </Container>
      </Navbar>

      {/* Animated bottom underline */}
      <div className="nav-underline"></div>

      {/* Mobile Menu */}
      <div
        className={`mobile-menu ${menuOpen ? "open" : ""} ${
          language === "ar" ? "rtl" : "ltr"
        }`}
      >
       <div className="menu-links">
  {nav.navlinks.map((item, index) => {
    const slug = item.key === "home" ? "/" : `/${item.key}`;
    const isDropdown = ["products", "company", "careers"].includes(item.key);
    const isOpen = activeDropdown === item.key;

    return (
      <div key={index} className="mobile-item">
        <div className="mobile-link-wrapper">
          {/* ✅ PRODUCTS: prevent navigation */}
          <Link
  to={isDropdown ? "#" : slug}
  className={`mobile-link ${
    location.pathname === slug ? "active" : ""
  }`}
  onClick={(e) => {
    if (isDropdown) {
      e.preventDefault();
      setActiveDropdown(activeDropdown === item.key ? null : item.key);
    } else {
      setMenuOpen(false);
      setActiveDropdown(null);
    }
  }}
>
  {item.label}
</Link>


          {/* ✅ Arrow for all dropdowns */}
          {isDropdown && (
            <span
              className="dropdown-arrow"
              onClick={(e) => {
                e.stopPropagation();
                setActiveDropdown(isOpen ? null : item.key);
              }}
            >
              <IoIosArrowDown />
            </span>
          )}
        </div>

        {/* ✅ Dropdown content */}
        {isDropdown && isOpen && (
          <div className="mobile-dropdown">
            {(item.key === "products"
              ? nav.productdrop
              : item.key === "company"
              ? nav.companydrop
              : nav.careersdrop
            ).map((sub, i) => (
              <Link
                key={i}
                to={
                  item.key === "products"
                    ? `/products/${sub.key}`
                    : item.key === "company"
                    ? `/company${sub.anchor}`
                    : `/careers/${sub.key}`
                }
                className="mobile-dropdown-item"
                onClick={() => {
                  setMenuOpen(false);
                  setActiveDropdown(null);
                }}
              >
                {sub.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  })}
</div>



        {/* Mobile Bottom section */}
        <div className="mobile-menu-bottom d-flex justify-content-between align-items-center mb-5 pb-5  px-3">
          <div className="lang-toggle" onClick={toggleLanguage}>
            {language === "en" ? "AR" : "EN"} <RiGlobalLine />
          </div>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>
            <div className="bt-head">{nav.letsTalk}</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
